import { createBasicSelector } from 'util/redux'
import { selectCurrentConversation } from './selectCurrentConversation'

export const selectCurrentTicketAssigneeId = createBasicSelector(
  selectCurrentConversation,
  ticket => ticket?.assigned?.agent
)
